import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
  hideHeader?: boolean;
  hideFooter?: boolean;
  fullPage?: boolean;
}

const Layout = ({ children, className = '', hideHeader = false, hideFooter = false, fullPage = false }: LayoutProps) => {
  return (
    <div className={`flex flex-col relative overflow-x-hidden ${fullPage ? 'min-h-screen' : 'h-screen overflow-hidden'}`}>
      {/* Ocean background */}
      <div className="fixed inset-0 -z-20"></div>
      
      {/* Animated waves */}
      <div className="fixed inset-0 -z-10">
        {/* First wave layer */}
        <div className="absolute inset-x-0 top-0 h-full opacity-20">
          {[...Array(2)].map((_, i) => (
            <div 
              key={`wave-1-${i}`} 
              className={`absolute w-full h-[100px] bg-wave-pattern bg-repeat-x animate-wave shimmer-effect`}
              style={{ 
                top: `${i * 250}px`, 
                animationDelay: `${i * 0.5}s`,
                opacity: 1 - (i * 0.15)
              }}
            ></div>
          ))}
        </div>
        
        {/* Second wave layer (reverse direction) */}
        <div className="absolute inset-x-0 top-0 h-full opacity-15">
          {[...Array(1)].map((_, i) => (
            <div 
              key={`wave-2-${i}`} 
              className={`absolute w-full h-[80px] bg-wave-pattern bg-repeat-x animate-wave-reverse shimmer-effect`}
              style={{ 
                top: `${120 + i * 250}px`, 
                animationDelay: `${i * 0.7}s`,
                opacity: 0.8 - (i * 0.15),
                transform: 'scaleX(-1)'
              }}
            ></div>
          ))}
        </div>
      </div>
      
      {!hideHeader && <Header />}
      <main className={`flex-1 ${fullPage ? '' : 'overflow-y-auto'} ${className}`}>
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout; 